import { 
  SliceColorStrip, PageKnowledgeHubLayout, PageKnowledgeHubLayoutProps,
  SliceColorStripProps, SliceContentEntityQuote, 
  SliceHeaderDivider, SliceHeaderDividerProps, SliceInlineBanner, SliceIntro, createSliceLayout,
  SliceContentImage,
  SlicePersonBioGrid,
  SlicePersonBioGridProps,
  SliceThumbnailStrip,
  SliceThumbnailStripProps,
  SlicePastEvents,
  SliceUpcomingEvents,
  SliceCurrentEvents,
  SlicePastEventsProps,
  SliceUpcomingEventsProps,
  SliceCurrentEventsProps,
 } from '@shapeable/ui';
import { BRAND_COLORS, LIGHT_BROWN } from '../../theme';
import { SliceSectionColorBlock, SliceSectionColorBlockProps } from '../entities/slice-section-color-block';
import { SliceCuratorCardsGrid } from '../entities/slice-curator-card-grid';

export const SliceLayoutIntroBackground = createSliceLayout(
  SliceInlineBanner, {
    boundary: 'content',
    aspectRatio: {
      base: 21 / 9,
    }
  }
);

export const SliceLayoutContentImage = createSliceLayout(
  SliceContentImage, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutKnowledgeHub = createSliceLayout<PageKnowledgeHubLayoutProps>(
  PageKnowledgeHubLayout, {
    boundary: 'content-bleed',
    verticalPadding: 'medium',
    props: {
      filterSize: 'slim',
      filterSpacing: 3,
      showAllTab: true,
      entityTypes: { 
        Post: { filterFieldNames: [ "type", "topics", "challenges", "authors"] }, 
        Video: { filterFieldNames: [ "topics", "challenges", "people" ] } 
      }
    }
  }
);

export const SliceLayoutKeyMessage = createSliceLayout(
  SliceContentEntityQuote, {
    boundary: 'none',
    themeMode: 'dark',
  }
);

export const SliceLayoutHeader = createSliceLayout<SliceHeaderDividerProps>(
  SliceHeaderDivider, {
    boundary: 'content',
    props: {
    }
  }
);

export const SliceLayoutColorStrip = createSliceLayout<SliceColorStripProps>(
  SliceColorStrip, {
    boundary: 'none',
    props: {
      colors: BRAND_COLORS
    }
  }
);

export const SliceLayoutIntro = createSliceLayout(
  SliceIntro, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutSection = createSliceLayout(
  SliceSectionColorBlock, {
    themeMode: 'dark',
    boundary: 'none',
  }
);

export const SliceLayoutSectionReverse = createSliceLayout<SliceSectionColorBlockProps>(
  SliceSectionColorBlock, {
    boundary: 'none',
    themeMode: 'dark',
    props: {
      isReversed: true
    }
  }
);

export const SliceLayoutPersonOrgsBioGrid = createSliceLayout<SlicePersonBioGridProps>(
  SlicePersonBioGrid, {
    verticalPadding: 'small',
    props: {
      showOrganisation: true,
      transform: 'greyscale'
    }
  }
);

export const SliceLayoutThumbnailStripBleed = createSliceLayout<SliceThumbnailStripProps>(
  SliceThumbnailStrip, {
    boundary: 'none',
    props: {
      bleed: 125,
    }
  }
);

export const SliceLayoutCuratorCardsGrid = createSliceLayout(
  SliceCuratorCardsGrid, {
    boundary: 'content',
  }
);

export const SliceLayoutPastEventsConcertina = createSliceLayout<SlicePastEventsProps>(
  SlicePastEvents, {
    verticalPadding: 'content',
    props: {
      showConcertina: true,
      colors: { text: LIGHT_BROWN }
    }
  }
);

export const SliceLayoutUpcomingEventsConcertina = createSliceLayout<SliceUpcomingEventsProps>(
  SliceUpcomingEvents, {
    verticalPadding: 'content',
    props: {
      showConcertina: true,
      colors: { text: LIGHT_BROWN }
    }
  }
);

export const SliceLayoutCurrentEventsConcertina = createSliceLayout<SliceCurrentEventsProps>(
  SliceCurrentEvents, {
    boundary: 'content',
    verticalPadding: 'content',
    props: {
      showConcertina: true,
      colors: { text: LIGHT_BROWN }
    }
  }
);
